import React from 'react'
import { CouponListByBrandSpace } from 'src/types/api'
import RenderIf from 'src/components/common/RenderIf'
import { Spinner } from 'src/components/common/Spinner'
import { BrandPageCouponSortOrderType, BrandPageProps } from 'src/pages/BrandPage'
import CustomSelect from 'src/components/common/CustomSelect'
import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Noto_body1_r16, Noto_body3_m12, Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import TopButton from 'src/components/common/TopButton'
import { Typography } from 'src/components/common/Typography'
import { Icon } from 'src/assets/svg/Icon'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import LazyImage from 'src/components/common/LazyImage'
import Skeleton from 'react-loading-skeleton'
import { Roboto_num1_b20 } from 'src/styles/fonts/RobotoFonts'
import { getBrandAndCouponName } from 'src/utils'

const onSaleCoupon = ({
  couponListByBrandData,
  alwaysCouponDetailPageNav,
  couponListByBrandNoMore,
  couponListByBrandQueryTarget,
  selectListItems,
  couponSortOrder,
  brandCouponSortHandler,
  isCouponListByBrandSuccess,
}: BrandPageProps) => {
  return (
    <S.BrandOnSale.Container $option="flex_column">
      <S.BrandStoreNoti.Container $option="flex_row">
        <Icon.Noti />
        <S.BrandStoreNoti.Text $fontStyle={Noto_body3_r12} $color="var(--black-50)">
          핫딜은 메인화면에서 확인해주세요.
        </S.BrandStoreNoti.Text>
      </S.BrandStoreNoti.Container>
      <S.BrandOnSale.Contents $option="flex_column">
        {isCouponListByBrandSuccess && couponListByBrandData?.length === 0 ? (
          <S.EmptyBrandItemsWrap $option="flex_column">
            <Typography $fontStyle={Noto_body1_r16} $color="var(--black-30)">
              등록된 상품이 없습니다.
            </Typography>
          </S.EmptyBrandItemsWrap>
        ) : (
          <React.Fragment>
            <S.BrandOnSale.SelectContainer $option="flex_row">
              <CustomSelect<BrandPageCouponSortOrderType>
                listItems={selectListItems}
                currentValue={couponSortOrder}
                selectOnchangeHandler={brandCouponSortHandler}
                customSelectWrapStyle={S.BrandOnSale.SelectWrap}
                defaultSelectWrapStyle={S.BrandOnSale.ClosedSelectStyle}
                activeSelectWrapStyle={S.BrandOnSale.ActiveSelectWrapStyle}
                openSelectWrapStyle={S.BrandOnSale.OpenSelectWrapStyle}
                openSelectItemsStyle={S.BrandOnSale.OpenSelectItemsStyle}
              />
            </S.BrandOnSale.SelectContainer>
            <S.CouponCard.List>
              {couponListByBrandData?.map(
                (
                  {
                    CouponImage,
                    CouponNumber,
                    CouponIdx,
                    CouponName,
                    SalePrice,
                    DiscountRate,
                  }: CouponListByBrandSpace.BrandCouponListType,
                  index: number,
                ) => {
                  return (
                    <S.CouponCard.Items
                      key={index}
                      $option="flex_column"
                      $row_gap="8px"
                      onClick={() => alwaysCouponDetailPageNav(CouponNumber, CouponIdx)}
                    >
                      <S.CouponCard.ImageWrap>
                        <LazyImage src={CouponImage} alt="쿠폰이미지" style={S.CouponCard.Image} />
                      </S.CouponCard.ImageWrap>
                      <RenderIf when={!SalePrice}>
                        <Skeleton width="100%" count={3} style={{ marginTop: '2px' }} />
                      </RenderIf>
                      <RenderIf when={!!SalePrice}>
                        <S.CouponCard.TextContainer $option="flex_column">
                          <Container $option="flex_row" $column_gap="4px">
                            <S.CouponCard.DiscountRate
                              $fontStyle={Roboto_num1_b20}
                              $color="var(--brand-50)"
                            >
                              {Math.floor((DiscountRate as number) * 10) / 10}%
                            </S.CouponCard.DiscountRate>
                            <S.CouponCard.SalePrice
                              $fontStyle={Roboto_num1_b20}
                              $color="var(--black-90)"
                            >
                              {SalePrice?.toLocaleString()}원
                            </S.CouponCard.SalePrice>
                          </Container>
                          <S.CouponCard.CouponBrand
                            $fontStyle={Noto_body3_m12}
                            $color="var(--black-90)"
                          >
                            {getBrandAndCouponName(CouponName).brandName}
                          </S.CouponCard.CouponBrand>
                          <S.CouponCard.CouponName
                            $fontStyle={Noto_body3_r12}
                            $color="var(--black-90)"
                          >
                            {getBrandAndCouponName(CouponName).couponName}
                          </S.CouponCard.CouponName>
                        </S.CouponCard.TextContainer>
                      </RenderIf>
                    </S.CouponCard.Items>
                  )
                },
              )}
            </S.CouponCard.List>
            <RenderIf when={!couponListByBrandNoMore && !(couponListByBrandData?.length === 0)}>
              <Spinner
                $color="var(--black-10)"
                ref={couponListByBrandQueryTarget}
                $margin="50px auto 0 auto"
              />
            </RenderIf>
            <TopButton isPosition="10px" />
          </React.Fragment>
        )}
      </S.BrandOnSale.Contents>
    </S.BrandOnSale.Container>
  )
}
export default onSaleCoupon

const S = {
  BrandOnSale: {
    Container: styled(Container)`
      width: 100%;
      margin: 0 auto;
      padding: 0 0 30px 0;
      flex: 1;
    `,
    Contents: styled(Container)`
      width: calc(100% - 40px);
      margin: 0 auto;
      height: 100%;
      flex: 1;
    `,
    SelectContainer: styled(Container)`
      justify-content: right;
      margin: 10px 0 14px 0;
    `,
    SelectWrap: css`
      width: 110px;
      display: flex;
      ${Noto_body3_r12};
    `,
    ClosedSelectStyle: css`
      display: flex;
      align-items: center;
      width: 100%;
      height: 30px;
      color: var(--black-70);
      text-align: center;
      cursor: pointer;
      gap: 10px;
      border: 1px solid var(--black-10);
      border-radius: 8px;
      padding: 6px 10px;
      justify-content: space-between;
    `,
    ActiveSelectWrapStyle: css`
      border-radius: 8px 8px 0 0;
      border-bottom: unset;
    `,
    OpenSelectWrapStyle: css`
      width: 100%;
      border-radius: 0 0 8px 8px;
      border-right: 1px solid var(--black-10);
      border-bottom: 1px solid var(--black-10);
      border-left: 1px solid var(--black-10);
      top: 30px;
      right: 0;
      z-index: 2;
    `,
    OpenSelectItemsStyle: css`
      color: var(--black-70);
      background-color: var(--white);
      padding: 6px 10px;
      &:hover,
      &:focus {
        background-color: var(--black-4);
      }
      &:nth-child(2) {
        border-radius: 0 0 8px 8px;
      }
    `,
  },
  CouponCard: {
    List: styled(Container)`
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fill, minmax(156px, 1fr));
      ${mediaMaxWidth('360')} {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      }
      row-gap: 30px;
      grid-column-gap: 8px;
    `,
    Items: styled(Container)`
      width: 100%;
      height: fit-content;
      cursor: pointer;
    `,
    ImageWrap: styled(Container)`
      position: relative;
      height: 0;
      padding-bottom: 100%;
    `,
    Image: css`
      position: absolute;
      top: 0;
      border-radius: 20px;
      outline: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      width: 100%;
      height: 100%;
      > img {
        border-radius: inherit;
      }
    `,
    TextContainer: styled(Container)``,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)``,
    CouponBrand: styled(Typography)`
      margin-top: 6px;
    `,
    CouponName: styled(Typography)`
      ${ellip('line2')};
    `,
  },
  EmptyBrandItemsWrap: styled(Container)`
    justify-content: center;
    text-align: center;
    flex: 1;
    height: 100%;
  `,
  BrandStoreNoti: {
    Container: styled(Container)`
      width: calc(100% - 20px);
      margin: 10px auto;
      text-align: center;
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.05);
      justify-content: center;
      align-items: center;
    `,
    Text: styled(Typography)`
      padding: 6px;
      display: block;
    `,
  },
}
